import API from '.';

export default class OperationStatus {
  /**
   * The operationStatus dimension table for UDM
   * @param {number} operationStatusId Id of the operationStatus.
   * @param {string} operationStatusName Name of the operationStatus.
   * @param {string} operationStatusDesc Description of the operationStatus.
   * @param {number} displayOrder Display order of the operationStatus dropdown.
   * @param {string} isActive 'Y' for active, 'N' for inactive.
   */
  constructor({ operationStatusId, operationStatusName, operationStatusDesc, displayOrder, isActive }) {
    this.operationStatusId = operationStatusId;
    this.operationStatusName = operationStatusName;
    this.operationStatusDesc = operationStatusDesc;
    this.displayOrder = displayOrder;
    this.isActive = isActive.toLowerCase() === 'y' ? true : false;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/operationStatus');
    return data.map((d) => new OperationStatus(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`operationStatus/${id}`);
    return new OperationStatus(data);
  }

  // static async create(data) {
  //   const api = await API();
  //   console.log(data);
  //   const { res } = await api.post('operationStatus', data);
  //   return res;
  // }

  // static async update (id, data) {
  //   const api = await API();
  //   const { res } = await api.put(`/operationStatus`, data);
  //   return res;
  // }
}
